import React from "react";
import ReactDOM from "react-dom/client";
import App from "views/App";
import AppProviders from "providers/AppProviders";
import "assets/styles/fonts.css";
const root = ReactDOM.createRoot(document.getElementById("calculator_app"));
// const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
